import $ from "jquery";

export default function initHashScroll() {
  if (window.location.hash) {
    var target = window.location.hash.slice(1);
    if (document.getElementById(target)) {
      $(function () {
        if (window.location.hash) {
          if ($("#" + target).length) {
            $("html, body").animate(
              {
                scrollTop: $("#" + target).offset().top - 50,
              },
              100
            );
          }
        }
      });
    }
  }
}
